export const DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG = {
  isSignupOTPRequired: true,
  globalSignOutEnabled: true,
  disableCartEDDMessaging: true,
  useCustomerSearch: false,
  disableForceEDDForAgeRestrictedProducts: false,
  disableAgeVerification: false,
  recentlyViewedProductsConstants: {
    recentlyViewedProductsCleanupTime: 2592000000,
    maxColorsPerProduct: 5,
    maxSavedRecentlyViewedProducts: 9,
    maxProductsDesktop: 8,
    maxProductsMobile: 9,
  },
}
